import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";
import { sell_InvoiceApi } from "../../app/slices/sell_InvoiceSlice";
import { Box, LinearProgress } from "@mui/material";
import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import { ContentCopy, Delete } from "@mui/icons-material";

import useFilterHandler from "../../components/filterhandler";
import Loader from "../digitalGold/Loader";
import Filter from "../../components/Filter";

export default function SellInvoice() {
  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });

const [filterData, setFilterData] = useState({
    startDate: "",
    endDate: "",
    metalType:"",
    merchantTransactionId:"",
    name: "",
     uniqueId: "",
  transactionId: "",
    customerRefNo: "",
   eyebtnforinvoice:""
  });

    const url = `/api/admin/augmont-sell-res/list`
  
    const { handleFilterSubmit, handleClearFilters, loader, results, apiCall,message,error,toastTrigger } = useFilterHandler(url, filterData, setFilterData)

  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };
  // useEffect(() => {
  //   dispatch(sell_InvoiceApi(queryParams));
  // }, [dispatch, queryParams]);

  useEffect(() => {
    apiCall(false)
  }, []);

   useEffect(() => {
  if (!message) return;

  console.log("Message updated:", message);

  if (error) {
    toast.error(message);
  }
  //  else {
  //   // toast.success(message);
  // }
}, [toastTrigger]);

  const sliceResponse = useSelector(
    (state) => state.sell_Invoice.sell_Invoice.data
  );
  const stateLoading = useSelector(
    (state) => state.sell_Invoice.loading
  );
  
  // loading={stateLoading}

  const columnHelper = createMRTColumnHelper();

  const columns = [
    // columnHelper.accessor("_id", {
    //   header: "ID",
    //   size: 30,
    //   Cell: ({ cell }) => {
    //     const handleCopy = () => {
    //       navigator.clipboard.writeText(cell.row.original?._id);
    //       toast.success("copied to clipboard!");
    //     };
    //     return (
    //       <Tooltip title={cell.row.original?._id}>
    //         <IconButton onClick={handleCopy}>
    //           <ContentCopy />
    //         </IconButton>
    //       </Tooltip>
    //     );
    //   },
    // }),
    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.customerRefNo);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.customerRefNo}>
            <>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.customerRefNo}
            </span>
            </>
          </Tooltip>
        );
      },
    }),

     columnHelper.accessor("userName", {
      header: "Name",
      size: 150,
      Cell: (cell) => cell.row.original?.userName,
    }),

     columnHelper.accessor("mobileNumber", {
      header: "Phone",
      size: 150,
      Cell: (cell) => cell.row.original?.mobileNumber ,
    }),

     columnHelper.accessor("uniqueId", {
      header: "Unique ID",
      size: 200,
      Cell: (cell) => cell.row.original?.uniqueId,
    }),

     columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 100,
      Cell: (cell) => cell.row.original?.metalType,
    }),

     columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 100,
      Cell: (cell) => cell.row.original?.quantity,
    }),

     columnHelper.accessor("rate", {
      header: "Metal Rate",
      size: 100,
      Cell: (cell) => cell.row.original?.rate,
    }),

    columnHelper.accessor("preTaxAmount", {
      header: "Pre Tax Amount",
      size: 100,
      Cell: (cell) => cell.row.original?.preTaxAmount,
    }),

      columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 100,
      Cell: (cell) => cell.row.original?.totalAmount,
    }),

     columnHelper.accessor("transactionId", {
      header: "Transaction ID",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.transactionId);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.transactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.transactionId}
            </span>
          </Tooltip>
        );
      },
    }),

     columnHelper.accessor("merchantTransactionId", {
      header: "Merchant Transaction ID",
      size: 200,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original?.merchantTransactionId);
          toast.success("copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original?.merchantTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original?.merchantTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),

     columnHelper.accessor("bankInfo.accountName", {
      header: "Account Name",
      size: 150,
      Cell: (cell) => cell.row.original?.bankInfo.accountName || "N/A",
    }),

     columnHelper.accessor("bankInfo.accountNumber", {
      header: "Account Number",
      size: 150,
      Cell: (cell) => cell.row.original?.bankInfo.accountNumber || "N/A",
    }),

       columnHelper.accessor("bankInfo.ifscCode", {
      header: "IFSC Code",
      size: 150,
      Cell: (cell) => cell.row.original?.bankInfo.ifscCode || "N/A",
    }),
   

    
   
 
    columnHelper.accessor("partner_id", {
      header: "Partner ID",
      size: 200,
      Cell: (cell) => cell.row.original?.partner_id,
    }),

    columnHelper.accessor("partner_username", {
      header: "Partner Username",
      size: 200,
      Cell: (cell) => cell.row.original?.partner_username,
    }),
   
    // columnHelper.accessor("sellTransactionDate", {
    //   header: "Sell Transaction Date",
    //   size: 150,
    // //   Cell: (cell) =>
    // //     new Date(cell.row.original?.sellTransactionDate).toLocaleString(),
    // // })
    //       Cell: (cell) => cell.row.original?.sellTransactionDate,
    // }),
    
   columnHelper.accessor("status", {
      header: "Status",
      size: 150,
      Cell: (cell) => cell.row.original?.status,
    }),
 
    //   columnHelper.accessor("goldBalance", {
    //   header: "Gold Balance",
    //   size: 150,
    //   Cell: (cell) => cell.row.original?.goldBalance,
    // }),

    //  columnHelper.accessor("silverBalance", {
    //   header: "Silver Balance",
    //   size: 150,
    //   Cell: (cell) => cell.row.original?.silverBalance,
    // }),

   
   
    // columnHelper.accessor("unitType", {
    //   header: "Unit Type",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.unitType,
    // }),
   
    // columnHelper.accessor("grossAmount", {
    //   header: "Gross Amount",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.grossAmount,
    // }),


  

    // columnHelper.accessor("userName", {
    //   header: "User Name",
    //   size: 150,
    //   Cell: (cell) => cell.row.original?.userName,
    // }),
    // columnHelper.accessor("userEmail", {
    //   header: "User Email",
    //   size: 200,
    //   Cell: (cell) => cell.row.original?.userEmail || "N/A",
    // }),
   
    // columnHelper.accessor("userCity", {
    //   header: "User City",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.userCity || "N/A",
    // }),
    // columnHelper.accessor("userState", {
    //   header: "User State",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.userState || "N/A",
    // }),
    // columnHelper.accessor("userPincode", {
    //   header: "User Pincode",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.userPincode || "N/A",
    // }),

    // Status
    // columnHelper.accessor("statusCode", {
    //   header: "Status Code",
    //   size: 100,
    //   Cell: (cell) => cell.row.original?.statusCode,
    // }),
    // columnHelper.accessor("message", {
    //   header: "Message",
    //   size: 200,
    //   Cell: (cell) => cell.row.original?.message,
    // }),

    //  columnHelper.accessor("cleanedUrl", {
    //   header: "Invoice Link",
    //   size: 200,
    //   Cell: (cell) => (
    //     <a
    //       href={cell.row.original?.cleanedUrl}
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       View Invoice
    //     </a>
    //   ),
    // }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 150,
      Cell: (cell) => cell.row.original?.createdAt?.split("T")[0],
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 150,
      Cell: (cell) => cell.row.original?.updatedAt?.split("T")[0],
    }),
  ];

  return (
    <>
     {/*  */}
      <Filter filterData={filterData} onFilterSubmit={handleFilterSubmit} Onclear={handleClearFilters} page={'augmont_sell_res'} setFilterData={setFilterData} />
        <>
          {/* <DateSearchComponent onSearch={handleSearch} /> */}
      <Box mt={2}>

         {loader?<Loader/>:<CustomTable columns={columns} data={results}   loading={loader} permissionKey="SellInvoices"
          />} 
          </Box>
        </>
      
    </>
  );
}
